import { StdResponse, coreAxios, monixAxios } from "@/declare/api/axios"
import { AxiosResponse } from "axios";

/**
 * 获取组列表
 * @param projectUuid 
 * @param params 
 * @returns 
 */
export function getGroups(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/groups`, {
        params: {
            ...params,
        }
    })
}

/**
 * 根据paramType获取二级组
 * @param projectUuid 
 * @param paramType 
 * @param params 
 * @returns 
 */
export function findSecondGroupsByParamType(projectUuid: string, paramType: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/second-groups`, {
        params: {
            ...params,
            paramType: paramType,
        }
    })
}